/**
 * Настройки обращения к API.
 *
 * Базовый адрес относительный, потому что кабинет и API обязаны быть одним источником:
 * refresh-сессия живёт в cookie `plnr_cabinet_rt` с SameSite=Strict, и при обращении
 * с другого источника браузер её не отправит. В разработке тот же источник даёт
 * прокси Vite (см. vite.config.ts), в бою — nginx.
 */
export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL ?? '/v1'

/**
 * Разбирать ли ответы схемами Zod.
 *
 * В разработке — да: расхождение контракта и сервера обязано падать громко и сразу.
 * В бою — нет, и это не экономия на спичках. Схема прав `PermissionCode` нарочно открытая,
 * но любое другое неожиданное поле в /me уронило бы разбор целиком, и человек не вошёл бы
 * в кабинет из-за поля, которым он не пользуется. Разбор дня журнала на пятнадцать мастеров
 * к тому же стоит заметного времени на каждом перелистывании даты.
 */
export const VALIDATE_RESPONSES: boolean = import.meta.env.DEV

/** Потолок ожидания одного запроса. Больше десяти секунд человек всё равно не ждёт. */
export const REQUEST_TIMEOUT_MS = 10_000

/**
 * Пауза перед единственным повтором обновления сессии, проигранного соседней вкладке
 * (409 session_refresh_raced). Величина случайная в этом окне: две вкладки, повторившие
 * запрос одновременно, снова столкнулись бы лбами.
 */
export const REFRESH_RACE_RETRY_MIN_MS = 200
export const REFRESH_RACE_RETRY_MAX_MS = 500
